import { UPDATE_THEME } from "app/actionTypes";

export const updateTheme = theme => {
	return {
		type: UPDATE_THEME,
		data: theme,
	};
};
